import { React, useState, useRef } from "react";
import useMeta from '../../../hooks/useMeta';

import './JobApplyForm_UI.css';
import { JobForm_Page_Data } from "../JobForm_Page_Data";

import Navbar from "../../../CommonComponent/Navbar/Navbar";
import NotificationBar from "../../../CommonComponent/Notification/NotificationBar";
import Footer from "../../../CommonComponent/Footer/footer";

import { useParams } from "react-router-dom";


const JobApplyForm_UI = () => {

    const { JobPagesID } = useParams();


    const Current_JobPage = JobForm_Page_Data[JobPagesID];

    const Job_TITLE = Current_JobPage?.Job_TITLE || null;
    const Job_DESCRIPTION = Current_JobPage?.Job_DESCRIPTION || null;
    const Job_LOCATION = Current_JobPage?.Job_LOCATION || null;

    const META_PG_OG_Title = Current_JobPage?.META_PG_OG_Title || '';
    const META_PG_OG_Description = Current_JobPage?.META_PG_OG_Description || '';
    const META_PG_Canonical_OG_URL = Current_JobPage?.META_PG_Canonical_OG_URL || '';

    useMeta({
        title: `${META_PG_OG_Title}`,
        description: `${META_PG_OG_Description}`,
        canonical: `${META_PG_Canonical_OG_URL}`,
        og: {
            locale: 'en_US',
            type: 'article',
            title: `${META_PG_OG_Title}`,
            description: `${META_PG_OG_Description}`,
            url: `${META_PG_Canonical_OG_URL}`,
            site_name: 'Callistus Blinds',
        },
    });

    const [formData, setFormData] = useState({
        name: "",
        phone: "",
        email: "",
        city: "",
        resume: null,
    });

    const handleChange = (e) => {
        const { name, value, files } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: files ? files[0] : value,
        }));
    };

    const handleReset = () => {
        setFormData({
            name: "",
            phone: "",
            email: "",
            city: "",
            resume: null,
        });
        document.getElementById("job-from-pg-form").reset();
    };

    const JobAppliactionSummited = async (e) => {
        e.preventDefault();

        const data = new FormData();
        data.append("name", formData.name);
        data.append("phone", formData.phone);
        data.append("email", formData.email);
        data.append("city", formData.city);
        data.append("jobtitle", Job_TITLE);
        data.append("resume", formData.resume);

        try {
            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/job-application`, {
                method: "POST",
                body: data, // no headers! browser sets multipart boundary automatically
            });

            const result = await response.json();
            if (response.success) {
                alert(`Job Application for ${Job_TITLE} submitted successfully!`);
                handleReset();
            } else {
                alert(result.message || "Failed to submit application.");
            }
        } catch (error) {
            console.error("Error submitting job application:", error);
            alert("An error occurred while submitting your application. Please try again later.");
        }
    };

    return (
        <>
            <Navbar />
            <NotificationBar />
            <div className="job-from-pg-container">
                <h1 className="job-from-pg-title">CAREER</h1>
                {Job_TITLE != null && (
                    <h2 className="job-from-pg-subtitle">{Job_TITLE}</h2>
                )}
                {Job_DESCRIPTION != null && (
                    <p className="job-from-pg-description">
                        {Job_DESCRIPTION}
                        {Job_LOCATION != null && (<><br />Location : {Job_LOCATION}</>)}
                    </p>
                )}

                <form id="job-from-pg-form" className="job-from-pg-form" onSubmit={JobAppliactionSummited} >
                    <div className="job-from-pg-row">
                        <div className="job-from-pg-field">
                            <label htmlFor="name">NAME<span>*</span></label>
                            <input
                                type="text"
                                id="name"
                                name="name"
                                placeholder="Your Name"
                                required
                                onChange={handleChange}
                            />
                        </div>
                        <div className="job-from-pg-field">
                            <label htmlFor="phone">PHONE<span>*</span></label>
                            <input
                                type="text"
                                id="phone"
                                name="phone"
                                placeholder="Your Phone Number"
                                required
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div className="job-from-pg-row">
                        <div className="job-from-pg-field">
                            <label htmlFor="email">EMAIL<span>*</span></label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                placeholder="Your Email"
                                required
                                onChange={handleChange}
                            />
                        </div>
                        <div className="job-from-pg-field">
                            <label htmlFor="city">CURRENT CITY<span>*</span></label>
                            <input
                                type="text"
                                id="city"
                                name="city"
                                placeholder="Current City"
                                required
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div className="job-from-pg-field job-from-pg-upload">
                        <label htmlFor="resume">UPLOAD YOUR RESUME<span>*</span></label>
                        <input
                            type="file"
                            id="resume"
                            name="resume"
                            accept=".pdf,.doc,.docx"
                            required
                            onChange={handleChange}
                        />
                        <p className="job-from-pg-file-note">
                            Acceptable file type: .pdf, .doc and .docx
                        </p>
                    </div>

                    <div className="job-from-pg-buttons">
                        <button type="submit" className="job-from-pg-btn">SUBMIT</button>
                        <button type="button" className="job-from-pg-btn" onClick={handleReset}>Reset</button>
                    </div>
                </form>
            </div>
            <Footer />
        </>
    );
};

export default JobApplyForm_UI;
